import {
  TGlobalOrderCancelPolicyCriteria,
  TGlobalOrderRefundType,
} from '~/api/services/global-order-api/index.type'
import {
  IProductPropertyCodeLocale,
  IProductPropertyLanguageValue,
} from '~/api/services/product-property/index.type'

export const AriProxyApiRatePlanPriceType = {
  B2B: 'B2B',
  B2C: 'B2C',
  FLIGHT: 'FLIGHT',
}
export type TAriProxyApiRatePlanPriceType =
  (typeof AriProxyApiRatePlanPriceType)[keyof typeof AriProxyApiRatePlanPriceType]

export interface IAriProxyApiRatePlanByRoomTypeQuery {
  member: boolean
  checkIn: string
  checkOut: string
  rooms: {
    adults: number
    children?: number[]
  }[]
  /** @deprecated 추후 provisionCode 로 대체 예정 */
  ratePlanId?: string
  provisionCode?: string
}

export interface IAriProxyApiRatePlanByRoomType {
  id: string
  propertyId: string
  version: string
  data: {
    id: string
    routerId: string
    propertyMasterId: string
    postalCode?: string
    address: IProductPropertyLanguageValue
    regions?: {
      type: string
      code: string
      value: IProductPropertyLanguageValue
    }[]
    country?: IProductPropertyCodeLocale
    coordinates?: {
      latitude?: number
      longitude?: number
    }
    timezone: {
      id: string
      offset: string
    }
    phone?: string
    fax?: string
    star: number
    starRating: number
    category: IProductPropertyCodeLocale
    chain?: {
      id?: string
      name?: string
    }
    brand?: {
      id?: string
      name?: string
    }
    groupAmenities?: {
      code?: string
      value?: IProductPropertyLanguageValue
      amenities?: IProductPropertyCodeLocale[]
    }[]
    filterAmenities?: IProductPropertyCodeLocale[]
    attributes?: {
      code?: string
      value?: IProductPropertyLanguageValue
    }[]
    photos: {
      url: string
      category: IProductPropertyCodeLocale
      weight: number
    }[]
    thumbnail: {
      url: string
      category: IProductPropertyCodeLocale
      weight: number
    }
    descriptions?: {
      overview?: IProductPropertyLanguageValue
      amenities?: IProductPropertyLanguageValue
      dining?: IProductPropertyLanguageValue
      renovations?: IProductPropertyLanguageValue
      nationalRatings?: IProductPropertyLanguageValue
      businessAmenities?: IProductPropertyLanguageValue
      rooms?: IProductPropertyLanguageValue
      attractions?: IProductPropertyLanguageValue
      location?: IProductPropertyLanguageValue
      checkinInstructions?: IProductPropertyLanguageValue
      checkinSpecialInstructions?: IProductPropertyLanguageValue
      policiesKnowBeforeYouGo?: IProductPropertyLanguageValue
      feesMandatory?: IProductPropertyLanguageValue
      feesOptional?: IProductPropertyLanguageValue
      houseManual?: IProductPropertyLanguageValue
    }
    ratesFrom: number
    reception?: {
      checkIn?: {
        beginTime?: string
        endTime?: string
        minAge?: number
      }
      checkOut?: {
        time?: string
      }
    }
    ratings?: {
      [key: string]: number
    }
    channels?: number[]
    channelId: number
    isOpen: boolean
    weight: number
    markupWeight?: number
  }
  ratePlans: {
    id: string
    displayName: {
      ko?: string
      en?: string
    }
    name?: IProductPropertyLanguageValue
    description?: IProductPropertyLanguageValue
    supplier: string
    filters: {
      filterId: number
      type: string
      value: string
    }[]
    amenities?: IProductPropertyCodeLocale[]
    surcharges?: {
      name: string
      charge: string
      // @deprecated amount 로 대체
      inclusive?: number
      amount: number
      currency: string
    }[]
    bedGroups?: {
      id: string
      configurations: {
        type: IProductPropertyCodeLocale
        quantity: number
      }[]
    }[]
    bedGroupsText?: string
    preferredOption?: {
      bedGroups?: {
        id: string
        value: string
      }[]
    }
    availableRooms: number
    existMemberOnly: boolean
    memberOnly: boolean
    promotion: boolean
    promotionText?: string
    /** 정가 */
    originPrice: number
    /** 방당 정가 */
    originPricePerRoom: number
    /** 판매가 */
    salePrice: number
    /** 판매가 (N객실 1박) */
    dailyPrices: {
      /** 세금 미포함 판매가 */
      exclusivePrice: number
      /** 판매가 */
      price: number
      /** 숙박일 */
      stayDate: string
    }[]
    /** 방당 가격 */
    salePricePerRoom: number
    /** 1박 1객실당 가격 */
    salePricePerRoomNight: number
    tax: number
    /** 정산기준가 */
    settlement: {
      value: number
      currency: string
    }
    isCancellable: boolean
    refund?: {
      type: TGlobalOrderRefundType
      endAt: string
    }
    cancelPolicies?: {
      startAt?: string
      endAt?: string
      criteria?: TGlobalOrderCancelPolicyCriteria
      night?: number
      ratio?: number
      amount?: number
    }[]
    priceType: TAriProxyApiRatePlanPriceType
    salePriceDiscountAmount?: number
    baseSalePrice: number
  }[]
  isBuilt: boolean
  published: boolean
  updatedAt: string
  memberClass?: string
}
